import React from 'react';
import { Users as UsersIcon, CheckCircle, XCircle } from 'lucide-react';

interface Stats {
  total: number;
  ativos: number;
  inativos: number;
}

interface UserStatsProps {
  stats: Stats;
}

const UserStats: React.FC<UserStatsProps> = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {/* Total */}
      <div className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-6 border border-gray-200/50 dark:border-gray-700/50 shadow-soft">
        <div className="flex items-center">
          <div className="p-3 rounded-xl bg-blue-100 dark:bg-blue-900/50 text-blue-600 dark:text-blue-400">
            <UsersIcon className="w-6 h-6" />
          </div>
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Total de Usuários</p>
            <p className="text-2xl font-bold text-gray-900 dark:text-gray-100">{stats.total}</p>
          </div>
        </div>
      </div>
      
      {/* Ativos */}
      <div className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-6 border border-gray-200/50 dark:border-gray-700/50 shadow-soft">
        <div className="flex items-center">
          <div className="p-3 rounded-xl bg-green-100 dark:bg-green-900/50 text-green-600 dark:text-green-400">
            <CheckCircle className="w-6 h-6" />
          </div>
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Usuários Ativos</p>
            <p className="text-2xl font-bold text-gray-900 dark:text-gray-100">{stats.ativos}</p>
          </div>
        </div>
      </div>
      
      {/* Inativos */}
      <div className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-6 border border-gray-200/50 dark:border-gray-700/50 shadow-soft">
        <div className="flex items-center">
          <div className="p-3 rounded-xl bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400">
            <XCircle className="w-6 h-6" />
          </div>
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Usuários Inativos</p>
            <p className="text-2xl font-bold text-gray-900 dark:text-gray-100">{stats.inativos}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserStats;
